import loginUser from './loginUser';
import createTokenRecoverPassword from './createTokenRecoverPassword';
import recoverPassword from './recoverPassword';
import loginUserByIdPath from './loginUserByIdPath';

export default {
  loginUser,
  createTokenRecoverPassword,
  recoverPassword,
  loginUserByIdPath,
}
